document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    const compare = form.closest('[data-product-root]')?.querySelector('[data-product-compare]');
    const savings = form.closest('[data-product-root]')?.querySelector('[data-product-savings]');
    const button = form.querySelector('[type="submit"]');

    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = option.dataset.discounted !== 'true';
      }
      if (savings) {
        savings.textContent = option.dataset.savings ? `Save ${option.dataset.savings}` : '';
        savings.hidden = option.dataset.discounted !== 'true';
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Unavailable';
      }
    });
  });

  document.querySelectorAll('[data-accordion-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  });

  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }
});
